<template v-show="showloader || member!==null">
  <v-container>
  <v-layout row wrap>
    <v-flex xs12 text-xs-center pt-4>
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>      
      <span class="primary--text font-weight-bold">&nbsp;&nbsp;LOADING....</span>
    </v-flex>  
  </v-layout>
  </v-container>
</template>

<template >

  <v-container v-show="memberStatusDetermined===true">
  <v-layout>
    
    <!--
  <template>
      <div class="loading-parent">
          <loading :active.sync="showloader" 
          :can-cancel="false" 
          :is-full-page="true"></loading>
      </div>
  </template>
-->
    <v-flex xs12 pa-0>
        <v-stepper v-model="e1" class="pa-0">
    <v-stepper-header class="pa-0">
      <v-stepper-step :complete="e1 > 1" step="1">Name of step 1</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">Name of step 2</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3" class="pa-0">Name of step 3</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items class="pa-0">
      <v-stepper-content step="1" class="pa-0">
              <v-card
          class="mb-5 pa-0"
          color="white lighten-1"
          
        >
        <v-subheader cass="headline"><span class="font-weight-black">REGISTER STEP 1. </span> &nbsp; Choose Member for Full Access</v-subheader>
        <v-card-text>
          
          <div class="text-md">
              
              <v-alert
                :value="true"
                type="success"
              >
                Congrats, You Successfully Logged In
              </v-alert>                

                    <v-container grid-list-md text-xs-left pa-0 caption id="fieldContainer">
                      <v-layout row  align-space-between justify-start >
                          <v-flex pa-0 xs3 class="fieldlabel">
                              <v-card flat tile><v-card-text>
                                  <v-tooltip bottom>
                                  <span slot="activator">Name: <v-icon small>help</v-icon></span>
                                  <span>This is the login name from your authentication provider</span>
                                  </v-tooltip>                                            
                              </v-card-text></v-card>
                          </v-flex>
                          <v-flex xs10 class="fieldvalue body font-weight-bold">
                              <v-card flat tile><v-card-text>
                                  <v-avatar
                                  size="35" 
                                  color="grey lighten-2"                                            
                                  ><img v-bind:src="user.photoUrl">
                                  </v-avatar>                                
                                {{user.displayName}}</v-card-text></v-card>
                          </v-flex>
                      </v-layout>
                      <v-divider  ></v-divider>
                      <v-layout row  align-space-between justify-start >
                          <v-flex pa-0 xs3 class="fieldlabel">
                              <v-card flat tile><v-card-text>Email:</v-card-text></v-card>
                          </v-flex>
                          <v-flex xs10 class="fieldvalue ">
                              <v-card flat tile><v-card-text>
                                   {{user.email}}                                       
                                  </v-card-text></v-card>
                          </v-flex>
                      </v-layout>
                      <v-divider  ></v-divider>

                  </v-container>              

              <v-alert
                :value="true"
                type="error"
              >
                But wait...there's more to do!
              </v-alert>              
              <div class="caption text--lighten-2">To continue, associate your access to an ACTUAL CHAPTER MEMBER. Below are suggestions based on the name above:</div>

              <h4 v-if="member" class="headline mb-0"><b class="red--text">Member :</b> {{ member.member }}</h4>
          </div>
          <div>
            <!--
            <v-select
            :items="matchingMembers"
            v-model="selectedMember"
            label="Choose Member"
            bottom
            >
              <template  slot="item" slot-scope="data">                
                 <span v-if="data.item" style="width:200px;">{{ data.item.firstname }} {{ data.item.lastname }} </span> <span v-if="data.item" style="color:blue;"> {{ data.item.lineid }}</span> 
              </template>    

              <template  slot="selection" slot-scope="data">                
                 <span v-if="data.item" style="width:200px;">{{ data.item.firstname }} {{ data.item.lastname }} </span> <span v-if="data.item" style="color:blue;"> {{ data.item.lineid }}</span> 
              </template>                  
                     
            </v-select>  
            -->
            <template v-if="matchingMembersUnregisteredNovrequest && matchingMembersUnregisteredNovrequest.length>0 ">
            <v-autocomplete
            v-if="matchingMembersUnregisteredNovrequest"
            :items="matchingMembersUnregisteredNovrequest"
            v-model="selectedMember"                                    
            label="Choose Actual Member"            
            chips
            small
            bottom
            prepend-icon="person"
            >
            <template  slot="item" slot-scope="data">                
                <span v-if="data.item" class="caption" style="width:200px;">{{ data.item.firstname }} {{ data.item.lastname }} </span> <span v-if="data.item" style="color:blue;"> {{ data.item.lineid }}</span> 
            </template>    

            <template  slot="selection" slot-scope="data">   
                <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="data.parent.selectItem(data.item)"
                >                                                     
                {{ data.item.firstname }} {{ data.item.lastname }} - {{ data.item.lineid }}
                </v-chip>
            </template>                  
                    
            </v-autocomplete>                       
            </template>
            <template v-else>
                <span class="body-2 red--text">No matching members auto-suggestions.</span>
            </template>
          </div>        


          <div>

                              
          </div>  
        </v-card-text>

        <v-card-actions>
        <v-btn
          small
          @click="step3"
          v-bind:disabled="isMemberNotSelected"
          dark 
          color="primary "
          class="btn-yes"
        >
          <v-icon>check_circle</v-icon>
          &nbsp; This is Me
        </v-btn>     


        <v-btn
          small
          @click="step2"
          dark 
          color="primary "
          class="btn-no"
        >
        <v-icon>far fa-eye</v-icon>
          &nbsp; Keep Looking
        </v-btn>
        </v-card-actions>
     </v-card>



      </v-stepper-content>

      <v-stepper-content step="2"
        color="white lighten-1"
        class="pa-0"
       >
        <v-card
          class="mb-5"
          color="white lighten-1"
          
        >
        <v-subheader cass="headline"><span class="font-weight-black">REGISTER STEP 2. </span> &nbsp; Choose Member for Full Access</v-subheader>
        <v-card-text>
          <div>
            <v-select
            :items="lines"
            v-model="selectedLine"
            label="Select Your Chapter Line"
            item-value="lineid"
            item-text="linename"
            bottom
            chips
            >
            
              <template slot="item" slot-scope="data">                
                <span class="caption" v-if="data.item">{{ data.item.lineyear }} ({{ data.item.lineseason }}) - {{ data.item.linename }} </span>
              </template>    
              <!--
              <template slot="selection" slot-scope="data">                
                <span v-if="data.item">{{ data.item.lineyear }} ({{ data.item.lineseason }}) - {{ data.item.linename }} </span>
              </template>    
              -->

              <!--
              <template slot="item" slot-scope="data">  
                <v-chip
                v-if="data.item"
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="data.parent.selectItem(data.item)"
                >                                                     
                {{ data.item.lineyear }} ({{ data.item.lineseason }}) - {{ data.item.linename }}
                </v-chip>  
                 </template>
                -->
              <template slot="selection" slot-scope="data">   
                <v-chip
                v-if="data.item"
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="data.parent.selectItem(data.item)"
                >                                                     
                {{ data.item.lineyear }} ({{ data.item.lineseason }}) - {{ data.item.linename }}
                </v-chip>  
                 </template>


            </v-select>          

          </div>

          <div v-if="selectedLine">
            <v-select
            :items="lineMembersUnregisteredNovrequest"
            v-model="selectedMember"
            label="Choose Actual Member"
            chips
            bottom
            >
              <template  slot="item" slot-scope="data">                
                <span class="caption" v-if="data.item" style="width:200px;">{{ data.item.firstname }} {{ data.item.lastname }} </span> <span v-if="data.item" class="caption" style="color:blue;"> {{ data.item.lineid }}</span> 
              </template>    

              <!--
              <template  slot="selection" slot-scope="data">                
                <span v-if="data.item" style="width:200px;">{{ data.item.firstname }} {{ data.item.lastname }} </span> <span v-if="data.item" style="color:blue;"> {{ data.item.lineid }}</span> 
              </template>                  
              -->   

              <template slot="selection" slot-scope="data">   
                <v-chip
                v-if="data.item"
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="data.parent.selectItem(data.item)"
                >                                                     
                {{ data.item.firstname }} {{ data.item.lastname }}
                </v-chip>  
                 </template>


            </v-select>          

          </div> 

        </v-card-text>
        <v-card-actions>
          <v-btn 
            small
            @click="step1"
            dark 
            color="primary lighten-2"
            >Back</v-btn>

          <v-btn
            small
            @click="step3"
            v-bind:disabled="step2ContinueButton"
            dark 
            color="primary lighten-2"
          >
            Continue
          </v-btn>

          <v-btn small dark 
          color="primary lighten-2"
          to="/"
          >Cancel</v-btn>
        </v-card-actions>
        
        </v-card>



      </v-stepper-content>

      <v-stepper-content step="3" class="pa-0">
        <v-subheader cass="headline"><span class="font-weight-black">FINAL STEP. </span> &nbsp; Request Member Verification</v-subheader>
        <v-card
          class="mb-5"
          color="white lighten-1"
          v-if="selectedMember"
        >

              <v-alert
                :value="true"
                type="success"
              >
                Ok, I hereby certify that the individual listed below is in fact ME.
              </v-alert>                

                    <v-container grid-list-md text-xs-left pa-0 caption id="fieldContainer">
                      <v-layout row  align-space-between justify-start >
                          <v-flex pa-0 xs3 class="fieldlabel">
                              <v-card flat tile><v-card-text>
                                  <v-tooltip bottom>
                                  <span slot="activator">Name: <v-icon small>help</v-icon></span>
                                  <span>This is the login name from your authentication provider</span>
                                  </v-tooltip>                                            
                              </v-card-text></v-card>
                          </v-flex>
                          <v-flex xs10 class="fieldvalue subheading">
                              <v-card flat tile><v-card-text>
                                  <v-avatar
                                  size="35" 
                                  color="grey lighten-2"                                            
                                  ><img v-bind:src="user.photoUrl">
                                  </v-avatar>                            
                                 {{selectedMember.firstname}} {{selectedMember.lastname}}</v-card-text></v-card>
                          </v-flex>
                      </v-layout>
                      <v-divider  ></v-divider>
                      <v-layout row  align-space-between justify-start >
                          <v-flex pa-0 xs3 class="fieldlabel">
                              <v-card flat tile><v-card-text>Email:</v-card-text></v-card>
                          </v-flex>
                          <v-flex xs10 class="fieldvalue ">
                              <v-card v-if="user.email" flat tile><v-card-text>
                                  {{user.email}}                                       
                                  </v-card-text></v-card>                             
                              <v-card v-else flat tile><v-card-text>
                                    <v-text-field
                                        v-model="user.email"
                                        placeholder="Enter a valid email address "
                                    ></v-text-field>                                          
                                  </v-card-text></v-card>                                 
                          </v-flex>
                      </v-layout>
                      <v-divider  ></v-divider>
                      <v-form v-model="validPhone">
                      <v-layout row  align-space-between justify-start >
                          <v-flex pa-0 xs3 class="fieldlabel">
                              <v-card flat tile><v-card-text>Phone:</v-card-text></v-card>
                          </v-flex>
                          <v-flex xs10 class="fieldvalue ">
                              <v-card flat tile><v-card-text>
                                    <v-text-field
                                        v-model="user.phone"
                                        :placeholder="validPhoneMessage"
                                        required
                                        :rules="phonefieldRules"                                        
                                    ></v-text-field>                                          
                                  </v-card-text></v-card>                                 
                          </v-flex>
                      </v-layout>
                      <v-divider  ></v-divider>                      
                      </v-form>
                  </v-container>              

              <v-alert
                :value="true"
                type="warning"
              >
                Next Steps. Click "YES, THIS IS ME" to initiate the verification process.
              </v-alert>              
              <div class="caption text--lighten-2">To ensure privacy, every new user must be VOUCHED FOR by at least 2 Registered Members. Please make sure the email/phone provided above are correct.</div>


        
        </v-card>

        <v-btn    
          small     
          dark 
          color="primary lighten-2"
          @click="step1"
        >
          Back
        </v-btn>

            <v-btn
              small
              dark 
              color="primary lighten-2"
              @click="completeRegistration"
              v-bind:disabled="isMemberNotSelected || validPhone===false"

            >
              Yes, This is Me
            </v-btn>     

        <v-btn small dark color="primary lighten-2" to="/" flat>Cancel</v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>


    </v-flex>




  </v-layout>
  </v-container>
</template>


<script>
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.min.css';


  export default {
    components:{
      Loading
    },
    data () {
      return {
        validPhone: false,
        validPhoneMessage: 'Enter a valid phone to continue',
        phonefieldRules: [
            v => !!v || 'Phone is required',
            v => (v && v.length >= 10 && /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(v)) || 'Field must be a valid phone number. '
        ],           
        e1: 0,        
        selectedLine: null,
        selectedMember: null,
        isMemberNotSelected: true,
        step2ContinueButton: true,
        showloader:true
      }
    },    
    created (){      
      console.log('created memberStatusDetermined - ' + this.memberStatusDetermined)
     
    },
    mounted (){
      console.log('mounted memberStatusDetermined - ' + this.memberStatusDetermined)
    },
    computed: {
      memberStatusDetermined () {
        return this.$store.getters.memberStatusDetermined
      }, 
      member () {
        return this.$store.getters.member
      }, 
      myColor () {
         return this.$store.getters.myColor
      },        
      user () {
        return this.$store.getters.user
      },
      userphone: {
        get() {
          return this.$store.getters.user.phone
        },
        set(val){
          if(this.validPhone){
            
            this.$store.commit('setUserphone', val)
          }
          
        }
      },
      userVrequestDoc () {
        var rtn = this.$store.getters.userVrequestDoc
        console.log('Register.vue computed userVrequestDoc this.$store.getters.userVrequestDoc ', rtn)
        return rtn
      },
      allVrequestDocs () {
          return this.$store.getters.allVrequestDocs
      },       

      lines () {
        return this.$store.getters.lines
      },    
      lineMembers () {
        return this.$store.getters.lineMembers
      },
      lineMembersUnregisteredNovrequest () {
        var selectedLineId = this.selectedLine
        //console.log('selectedLine', this.selectedLine)
        //console.log('selectedLineId', selectedLineId)
        //console.log('this.$store.getters.sortedLinesAndMembers', this.$store.getters.sortedLinesAndMembers)
        var lms = null
        var tmpLine = this.$store.getters.sortedLinesAndMembers.filter(function(objline){ return objline.lineid ===selectedLineId })
        //console.log('tmpLine', tmpLine)
        if(tmpLine){
          //console.log('tmpLine exists setting lms')
          lms = tmpLine[0].linemembers
        }

        //console.log('lms', lms)
        if(lms){
          lms = lms.filter(function(m){return (!m.userid || m.userid===null)})
          //console.log('lms filtered', lms)
          var vreqs = this.$store.getters.allVrequestDocs
          for(var i=0; i<vreqs.length; i++){
            var vreqmemberlineid = vreqs[i].memberlineid
            var vreqmembermember = vreqs[i].member
            lms = lms.filter(function(m){ return ((vreqmemberlineid===m.lineid &&  vreqmembermember===m.member)===false)})
          }
          //console.log('lms filtered again', lms)
        }
        //console.log('lms final', lms)
        return lms
      },              
      error () {
        return this.$store.getters.error
      },
      loading () {
        return this.$store.getters.loading
      },
      matchingMembers () {
        return this.$store.getters.matchingMembers
      },
      matchingMembersUnregisteredNovrequest () {
        var mms = this.$store.getters.matchingMembers
        if(mms){
          mms = mms.filter(function(m){return (!m.userid)})
          var vreqs = this.$store.getters.allVrequestDocs
          if(vreqs){
            for(var i; i<vreqs.length; i++){
              var vreqmemberlineid = vreqs[i].memberlineid
              var vreqmembermember = vreqs[i].member
              mms = mms.filter(function(m){return ((m.lineid===vreqmemberlineid &&  m.member ===vreqmembermember)===false)})
            }
          }

        }

        return mms
      },      
      selectedLineComputed () {
        return this.selectedLine
      },
      selectedMemberComputed () {
        return this.selectedMember
      }      
    },
    watch: {
      memberStatusDetermined (value){
        console.log('watch memberStatusDetermined value' + value)
        if(value===false){
          this.showloader=true
        }else{
          this.showloader=false

        }
        console.log('watch memberStatusDetermined showloader ' + this.showloader)
      },
      member (value) {
        if (value !== null && value !== undefined) {
            console.log('pushingrouter to  /profile from register.vue (member watch)')
            this.$router.push('/profile')
        }
      },
      userVrequestDoc (value){
        if(value){
          this.$router.push('/profile')
        }
      },

      selectedLineComputed (value) {
        if (value !== null && value !== undefined) {
            //console.log('selectedLineComputed: ', value)
            //TODO: enable button
            this.step2ContinueButton = false
        }        
      },
      selectedMemberComputed (value) {
        if (value !== null && value !== undefined) {
            console.log('selectedMemberComputed: ', value)
            //this.$store.dispatch('loadMember',{value})
            //TODO: enable button
            this.isMemberNotSelected = false
        }        
      }      

    },
    methods: {
      step1: function () {
        this.e1 = 1
        this.selectedMember = null
        this.isMemberNotSelected=true
      },      
      step2: function () {
        this.e1 = 2
        this.selectedMember = null
        this.isMemberNotSelected=true
        //this.populateLines()
      },
      step3: function () {
        this.e1 = 3
        console.log('step3 selected member',this.selectedMember )

      },  
      /*    
      populateLines: function () {
        this.$store.dispatch('loadLines')
      },
      */
      completeRegistration: function () {
        //console.log('in completeRegistration')

        var tmpObjVerificationRequest = new Object()
        tmpObjVerificationRequest.user = this.user
        tmpObjVerificationRequest.verifiers = []
        console.log('completeRegistration tmpObjVerificationRequest.user',tmpObjVerificationRequest.user)
        console.log('completeRegistration this.selectedMember',this.selectedMember)
        tmpObjVerificationRequest.member = this.selectedMember

        this.$store.dispatch('requestMemberVerification', tmpObjVerificationRequest)
      },
        getUrlVars: function(name) {
            var vars = {};
            var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
                vars[key] = value;
            });
            return vars;
        }             

    }

  }
</script>

<style>
#postFieldList .v-subheader{
    width:110px;
    padding-left: 0px;
    background-color: ghostwhite;
    margin-right: 8px;
}

#postComments .v-card{
    background-color:blue;
}
#fieldContainer .v-card__text{
    padding:5px;
}
.fieldlabel, .fieldlabel .v-card{
    background-color: ghostwhite;
    text-align: left;
}

.convo-card{
  border-radius:15px;
 
}


.chat-card{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-me{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-date{
    text-align: right;
    margin-right:15px;
    color:dimgrey;
}

.btn-no{
  background-color: #ff5252 !important;
}

.btn-yes{
  background-color: #4caf50 !important;
}
</style>